import React, { useCallback, useEffect, useState } from 'react';
import { Box, Link, TableCell, TableRow, Typography } from '@mui/material';

// COMPONENTS
import CardWrapper from '../../CardWrapper';
import Loader from '../../../common/Loader';
import DashboardTable from '../../DashboardTable';

// MESSAGES
import HomeFormattedMessages from '../../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../../requests/DashboardRequest';

// UTILS
import { getTimeRangeValue } from '../../../../utils/timeRanges';

export default function CustomerTopErrors({
  activeCustomerName,
  navigate,
  mobileView,
  errorHandler,
}) {
  const [errorData, setErrorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getCustomerTopError } = useDashboardRequest();

  const columns = [
    { id: 'period', label: 'Period' },
    { id: 'code', label: 'Code', align: 'right' },
    { id: 'description', label: 'Description', align: 'right' },
    { id: 'qty', label: 'Qty', align: 'right' },
  ];

  const loadData = useCallback(async () => {
    if (!mobileView) {
      setLoading(true);
      const response = await getCustomerTopError(errorHandler);
      setErrorData(response);
    }

    setLoading(false);
  }, [mobileView]);

  const handlePageNavigation = (item) => {
    localStorage.setItem('timeRange', getTimeRangeValue(item.period));

    navigate('/reports/message', {
      state: {
        error_code: item.errorCodeDescription,
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <CardWrapper
      title={
        <>
          {!mobileView ? `${activeCustomerName} ` : ''}
          {HomeFormattedMessages.topError}
        </>
      }
      icon="warning"
      goToLink="/reports/message"
      goToLinkState={{
        status: 'Failed Delivery',
      }}
      goToLinkText="Go to Message Reports"
      goToLinkSetTimeRange={mobileView ? '24 hrs' : 0}
      navigate={navigate}
      subtitle={mobileView && HomeFormattedMessages.last24Hours}
    >
      {loading ? (
        <Loader />
      ) : errorData.length === 0 && !mobileView ? (
        <Box sx={{ marginTop: 2 }}>
          <Typography>{HomeFormattedMessages.noDataAvailable}</Typography>
        </Box>
      ) : !mobileView ? (
        <Box>
          <DashboardTable columns={columns}>
            {errorData.map((item, index) => (
              <TableRow key={`row_${index}`}>
                <TableCell>{item.period}</TableCell>
                <TableCell align="right">
                  {item.error_code_text !== 'No Errors' ? (
                    <Link
                      component="button"
                      onClick={() => handlePageNavigation(item)}
                    >
                      {item.error_code_text}
                    </Link>
                  ) : (
                    'N/A'
                  )}
                </TableCell>
                <TableCell align="right">
                  {item.errorCodeDescription === 'No Errors'
                    ? 'N/A'
                    : item.errorCodeDescription}
                </TableCell>
                <TableCell align="right">{item.count}</TableCell>
              </TableRow>
            ))}
          </DashboardTable>
        </Box>
      ) : null}
    </CardWrapper>
  );
}
